import React, { useMemo } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { filterItem_navigationAppsSidebarCommon$key } from '@atlassian/jira-relay/src/__generated__/filterItem_navigationAppsSidebarCommon.graphql';
import { MenuItem } from '../menu-item/main.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const selectedOn = (currentLocation: any, itemLocation: any) =>
	itemLocation.query.filter === (currentLocation.query.filterId || currentLocation.query.filter);

type customAnalytics = {
	isStarred?: boolean;
};

type Props = {
	baseHref: string;
	filter: filterItem_navigationAppsSidebarCommon$key;
	customAnalytics?: customAnalytics;
};

export const FilterItem = ({ baseHref, filter, customAnalytics }: Props) => {
	const { filterId, name } = useFragment(
		/* eslint-disable @atlassian/relay/unused-fields */
		graphql`
			fragment filterItem_navigationAppsSidebarCommon on JiraFilter {
				filterId
				isFavourite
				jql
				name
				... on JiraCustomFilter {
					isEditable
				}
			}
		`,
		/* eslint-enable @atlassian/relay/unused-fields */
		filter,
	);

	const analyticsAttributes = useMemo(
		() => ({ ...(customAnalytics || {}), itemId: `filter-${filterId}` }),
		[customAnalytics, filterId],
	);

	return (
		<MenuItem
			key={filterId}
			analytics={analyticsAttributes}
			selectedOn={selectedOn}
			href={`${baseHref}?filter=${filterId}`}
		>
			{name}
		</MenuItem>
	);
};
